<template>
  <div></div>
</template>
<script>
import wx from 'weixin-js-sdk'
import {  jssdkConfig, jssdkCardConfig, decrpytCard } from '@/api/login'

export default {
  name: 'tickets',
  redirectUrl: null,
  data() {
    return {
    }
  },
  created() {
    let url = location.href.split('#')[0]
    jssdkConfig(url).then(res => {
        console.log('got data')
        console.log(res)
        wx.config({
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          // debug:true,
          jsApiList: ['chooseCard', 'openCard']
        })
        wx.ready(() => {
          console.log('ready')
          this.fetchCards()
        })

        wx.error(function(error) {
          console.log(error)
        })
      })
      .catch(function(error) {
        console.log(error);
      })
  },
  methods: {
    fetchCards() {
      let url = location.href.split('#')[0]
      jssdkCardConfig(url).then(res => {
        wx.chooseCard({
          timestamp: res.timestamp, // 卡券签名时间戳
          nonceStr: res.nonceStr, // 卡券签名随机串
          signType: 'SHA1', // 签名方式，默认'SHA1'
          cardSign: res.signature, // 卡券签名
          success: function(res) {
            console.log('choose card:')
            console.log(res)
            let card = JSON.parse(res.cardList)[0] // 狗屎微信，返回string
            console.log('first card:')
            console.log(card)
            decrpytCard(card.encrypt_code).then(res => {
              wx.openCard({
                cardList: [{ cardId: card.card_id, code: res.code }],
                success: function(openRes) {
                  console.log(openRes)
                }
              })
            })

          },
          fail: function(res) {
            console.log(res)
          }
        })
      })
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/tickets.vue